<template>
  <div id="home">
    <Header class="home-header"></Header>
    <!-- <Header class="home-header" :title_one="'MIC'"></Header> -->
    <!-- <div class="background"></div> -->
    <div id="content">
      <v-container fluid grid-list-md>
        <!-- <h1 class="home-title">{{ $t('home.welcome') }}<span v-if="!user.admin" class="name"> {{user.name}}</span></h1>

        <p class="description">{{ user.admin ? $t('home.description_club') : $t('home.description_team') }}</p>

         <p v-if="!user.admin" class="description">{{team.name}}</p> -->

        <!-- Regular user -->
        <!-- <div v-if="!user.admin" class="alerts">

          <div v-if="team.estimate_players <= 0" class="alert" :class="{'error':team.estimate_players_error}">
            <div class="info">
              <p class="text">{{ $t('params.ask_estimated_players') }}</p>
              <span class="message_error" v-html="$t('errors.estimate_players', {s: team.category.minimum_players})"></span>
            </div>
            <div class="actions">
              <input class="value" type="number" min="1" v-model="team.input_estimate_players">
              <button type="button" class="btn" @click="updateEstimate('players')">{{$t('update') }}</button>
            </div>
          </div>

          <div v-if="team.estimate_staff <= 0" class="alert" :class="{'error':team.estimate_staff_error}">
            <div class="info">
              <p class="text">{{ $t('params.ask_estimated_staff') }}</p>
              <span class="message_error" v-html="$t('errors.estimate_staff')"></span>
            </div>
            <div class="actions">
              <input class="value" type="number" min="1" v-model="team.input_estimate_staff">
              <button type="button" class="btn" @click="updateEstimate('staff')">{{$t('update') }}</button>
            </div>
          </div>

          <div v-if="team.estimate_acompanyants == null" class="alert" :class="{'error':team.estimate_acompanyants_error}">
            <div class="info">
              <p class="text">{{ $t('params.ask_estimated_acompanyants') }}</p>
              <span class="message_error" v-html="$t('errors.estimate_acompanyants')"></span>
            </div>
            <div class="actions">
              <input class="value" type="number" min="0" v-model="team.input_estimate_acompanyants">
              <button type="button" class="btn" @click="updateEstimate('acompanyants')">{{$t('update')}}</button>
            </div>
          </div>

          <div v-if="team.estimate_players != team.players && team.estimate_players != 0" class="alert informative" @click="redirect(team.id, 'players')">
            <div class="info">
              <p class="text">{{ $t('params.info_estimated_players', {s: '' }) }}</p>
            </div>
          </div>

          <div v-if="team.estimate_staff != team.staff && team.estimate_staff != 0" class="alert informative"  @click="redirect(team.id, 'staff')">
            <div class="info">
              <p class="text">{{ $t('params.info_estimated_staff', {s: '' }) }}</p>
            </div>
          </div>

          <div v-if="team.estimate_acompanyants != team.acompanyants && team.estimate_acompanyants != 0" class="alert informative"  @click="redirect(team.id, 'acompanyants')">
            <div class="info">
              <p class="text">{{ $t('params.info_estimated_acompanyants', {s: '' }) }}</p>
            </div>
          </div>

          <div v-if="(team.estimate_players != 0 && team.estimate_staff != 0 && team.estimate_acompanyants != null)
                      && team.estimate_players == team.players && team.estimate_staff == team.staff && team.estimate_acompanyants == team.aompanyants" class="alerts-empty">
            {{ $t('home.empty_alerts') }}
          </div>
        </div> -->

        <!-- Admin user -->
        <!-- <div class="layout" v-if="user.admin">
          <div class="teamInfo" v-for="team in teams" v-bind:key="team.id">

            <h6 class="team" v-on:click="redirect(team.id,'team')" >
              <span class="category">{{$t('params.category')}} {{team.category.name}}</span>
              <span class="name">{{ team.name ? team.name : club.name +" "+ team.category.name}}</span>
            </h6>

            <div class="resume">
              <div class="item" v-on:click="redirect(team.id,'players')" :class="{'empty':team.estimate_players <= 0}">
                <span class="value">{{ team.players }}<span class="total">/{{ team.estimate_players }}</span></span>
                <span class="label">{{ $t('titles.players') }}</span>
              </div>
              <div class="item" v-on:click="redirect(team.id,'staff')" :class="{'empty':team.estimate_staff <= 0}">
                <span class="value">{{ team.staff }}<span class="total">/{{ team.estimate_staff }}</span></span>
                <span class="label">{{ $t('titles.staff') }}</span>
              </div>
              <div class="item" v-on:click="redirect(team.id,'acompanyants')" :class="{'empty':team.estimate_acompanyants == null}">
                <span class="value">{{ team.acompanyants }} <span class="total" v-if="team.estimate_acompanyants > 0">/{{team.estimate_acompanyants}}</span> </span>
                <span class="label">{{ $t('titles.acompanyants') }}</span>
              </div>
            </div>

            <div class="actions" v-if="team.estimate_players <= 0 || team.estimate_staff <= 0 || team.estimate_acompanyants == null" >

              <div v-if="team.estimate_players <= 0" class="alert" :class="{'error':team.estimate_players_error}">
                <div class="info">
                  <p class="text">{{ $t('params.ask_estimated_players') }}</p>
                  <span class="message_error" v-html="$t('errors.estimate_players',{s: team.category.minimum_players})"></span>
                </div>
                <div class="actions">
                  <input class="value" type="number" min="1" v-model="team.input_estimate_players" v-on:keyup.enter="updateEstimate('players',team)">
                  <button type="button" class="btn" @click="updateEstimate('players',team)">{{$t('update') }}</button>
                </div>
              </div>

              <div v-if="team.estimate_staff <= 0" class="alert" :class="{'error':team.estimate_staff_error}">
                <div class="info">
                  <p class="text">{{ $t('params.ask_estimated_staff') }}</p>
                  <span class="message_error" v-html="$t('errors.estimate_staff')"></span>
                </div>
                <div class="actions">
                  <input class="value" type="number" min="1" v-model="team.input_estimate_staff" v-on:keyup.enter="updateEstimate('staff',team)">
                  <button type="button" class="btn" @click="updateEstimate('staff',team)">{{$t('update') }}</button>
                </div>
              </div>

              <div v-if="team.estimate_acompanyants == null" class="alert" :class="{'error' : team.estimate_acompanyants_error}">
                <div class="info">
                  <p class="text">{{ $t('params.ask_estimated_acompanyants') }}</p>
                  <span class="message_error" v-html="$t('errors.estimate_acompanyants')"></span>
                </div>
                <div class="actions">
                  <input class="value" type="number" min="0" v-model="team.input_estimate_acompanyants" v-on:keyup.enter="updateEstimate('acompanyants',team)">
                  <button type="button" class="btn" @click="updateEstimate('acompanyants',team)">{{$t('update')}}</button>
                </div>
              </div>

            </div>

            <div v-if="Object.keys(team.gestor).length > 0" class="gestor">
              {{$t('titles.gestor') +": "+ team.gestor.name}}
            </div>
            <div v-else class="gestor empty" @click="redirect(team.id,'gestorAdd')">
              {{ $t('add_gestor') }}
            </div>

          </div>
        </div> -->
      </v-container>
    </div>
  </div>
</template>

<script>
/* global isEmpty */
import Header from '@/components/layout/Header'

export default {
  name: 'Home',
  components: { Header },
  data () {
    return {
      // user: {},
      club: {},
      team: {}, // only for regular user
      teams: {},
      players: {},
      staff: {},
      acompanyants: {},
      responsables: {}
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    }
  },
  beforeCreate () {
    var event = this.$store.getters.getCurrentEvent()
    // alert( event.is_campus );
    if (event.is_campus) {
      this.$router.push({
        name: 'campus_home',
        params: { event: this.$root.formatEventUrl(event.name, event.edition) }
      })
    } else {
      this.$router.push({
        name: 'club',
        params: { event: this.$root.formatEventUrl(event.name, event.edition) }
      })
    }
    this.$destroy()
  },
  created () {
    this.user.admin ? this.isAdmin() : this.isUser()
  },
  methods: {
    redirect (id, path) {
      path !== 'team'
        ? this.$router
          .push({ name: path, params: { team_id: id } })
          .catch()
        : this.$router
          .push({ name: path, params: { id: id } })
          .catch()
    },

    /**
     * If user is admin, show list of teams
     */
    isAdmin () {
      var self = this
      if (!this.user.club_id) return true
      // get club information
      this.$store
        .dispatch('club/loadClubEvent', {
          club_id: this.user.club_id,
          event_id: this.user.event_id
        })
        .then(function () {
          self.club = self.$store.getters['club/getClub']
          self.teams = JSON.parse(JSON.stringify(self.club.teams)) // Clone Ojbect
          // loop for teams
          for (var team in self.teams) {
            // init inputs
            self.teams[team].input_estimate_players = ''
            self.teams[team].input_estimate_staff = ''
            self.teams[team].input_estimate_acompanyants = ''
            // variables for errors
            self.teams[team].estimate_players_error = false
            self.teams[team].estimate_staff_error = false
            self.teams[team].estimate_acompanyants_error = false
          }
          self.players = self.club.players
          self.staff = self.club.staff
          self.acompanyants = self.club.acompanyants
          self.responsables = self.club.responsables
        })
    },

    /**
     * If user is not admin, show only the team
     */
    isUser () {
      var self = this
      // get team information
      if (!this.$store.getters.getCurrentEvent().is_campus) {
        this.$store
          .dispatch('team/loadTeam', { team_id: this.user.team_id })
          .then(function () {
            // get team info
            var data = self.$store.getters['team/getTeam']
            self.club = data.club
            // clone object
            self.team = JSON.parse(JSON.stringify(data.team))
            // init inputs
            self.team.input_estimate_players = ''
            self.team.input_estimate_staff = ''
            self.team.input_estimate_acompanyants = ''
            // get team data
            self.players = data.players
            self.staff = data.staff
            self.acompanyants = data.acompanyants
            self.responsables = data.responsables
            // variables for errors
            self.team.estimate_players_error = false
            self.team.estimate_staff_error = false
            self.team.estimate_acompanyants_error = false
          })
      }
    },
    updateEstimate (type, team = false) {
      // check if team is false = regular user, get team
      if (!team) {
        team = this.team
      }
      // clone object to avoid problems
      this.team = JSON.parse(JSON.stringify(team))
      this.teams = JSON.parse(JSON.stringify(this.teams))
      // validate players
      if (type === 'players') {
        if (
          isEmpty(team.input_estimate_players) ||
          parseInt(team.input_estimate_players) <
            parseInt(team.category.minimum_players)
        ) {
          // add error
          this.user.admin
            ? (this.teams[team.id].estimate_players_error = true)
            : (this.team.estimate_players_error = true)
        } else {
          // remove error
          this.user.admin
            ? (this.teams[team.id].estimate_players_error = false)
            : (this.team.estimate_players_error = false)
          // update
          var self = this
          this.$store
            .dispatch('team/updateEstimatePlayers', {
              team_id: team.id,
              input: {
                estimate_players: team.input_estimate_players,
                estimate_staff: team.estimate_staff,
                estimate_acompanyants: team.estimate_acompanyants
              }
            })
            .then(function () {
              self.user.admin ? self.isAdmin() : self.isUser()
            })
        }
      }
      // validate staff
      if (type === 'staff') {
        if (
          isEmpty(team.input_estimate_staff) ||
          parseInt(team.input_estimate_staff) < 1
        ) {
          // add error
          this.user.admin
            ? (this.teams[team.id].estimate_staff_error = true)
            : (this.team.estimate_staff_error = true)
        } else {
          // remove error
          this.user.admin
            ? (this.teams[team.id].estimate_staff_error = false)
            : (this.team.estimate_staff_error = false)
          // update
          this.$store
            .dispatch('team/updateEstimatePlayers', {
              team_id: team.id,
              input: {
                estimate_players: team.estimate_players,
                estimate_staff: team.input_estimate_staff,
                estimate_acompanyants: team.estimate_acompanyants
              }
            })
            .then(function () {
              self.user.admin ? self.isAdmin() : self.isUser()
            })
        }
      }
      // validate acompanyants
      if (type === 'acompanyants') {
        if (
          isEmpty(team.input_estimate_acompanyants) ||
          parseInt(team.input_estimate_acompanyants) < 0
        ) {
          // add error
          this.user.admin
            ? (this.teams[team.id].estimate_acompanyants_error = true)
            : (this.team.estimate_acompanyants_error = true)
        } else {
          // remove error
          this.user.admin
            ? (this.teams[team.id].estimate_acompanyants_errorr = false)
            : (this.team.estimate_acompanyants_error = false)
          // update
          this.$store
            .dispatch('team/updateEstimatePlayers', {
              team_id: team.id,
              input: {
                estimate_players: team.estimate_players,
                estimate_staff: team.estimate_staff,
                estimate_acompanyants: team.input_estimate_acompanyants
              }
            })
            .then(function () {
              self.user.admin ? self.isAdmin() : self.isUser()
            })
        }
      }
    }
  },
  watch: {
    'team.estimate_players': function () {
      parseInt(this.team.estimate_players) <= this.team.minimum_players
        ? (this.team.estimate_players_error = true)
        : (this.team.estimate_players_error = false)
    },
    'team.estimate_staff': function () {
      parseInt(this.team.estimate_staff) < 1
        ? (this.team.estimate_staff_error = true)
        : (this.team.estimate_staff_error = false)
    },
    'team.estimate_acompanyants': function () {
      parseInt(this.team.estimate_acompanyants) < 0
        ? (this.team.estimate_acompanyants_error = true)
        : (this.team.estimate_acompanyants_error = false)
    },
    'user.team_id': function () {
      this.user.admin ? this.isAdmin() : this.isUser()
    }
  }
}
</script>

<style lang="scss" scoped>
.home-header {
  display: none;
}

#home {
  .background {
    @include background(
      $image: img("home_bg.jpg"),
      $size: cover,
      $position: bottom center
    );
    height: 200px;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }

  #content {
    position: relative;
    z-index: 2;
    background: none;
    // padding-top: 150px;
  }

  .home-title {
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    color: $main-color;
    padding: 18px 0 0px 0;

    &:after {
      content: "";
      display: block;
      height: 2px;
      width: 40px;
      background-color: $secondary-color;
      margin: 24px auto 6px auto;
    }

    .name {
      text-transform: capitalize;
      font-size: inherit;
      color: inherit;
    }
  }

  .description {
    width: 100%;
    margin: 0 auto 42px auto;
    text-align: center;
    font-size: 22px;
    line-height: 22px;
    color: #777;
  }

  .alerts {
    margin-top: 60px;
  }
  .alerts-empty {
    @include font-size(18px);
    color: #aaa;
    text-align: center;
    padding: 50px 30px;
    font-family: $text-light;
  }

  .alert {
    @include display-flex();
    @include align-items();
    @include flex-wrap(wrap);
    @include background(
      $color: $warning-color-light,
      $image: img("empty_estimated_warning.svg"),
      $position: left 12px center,
      $size: 30px
    );
    width: 60%;
    // min-height: 100px;
    height: auto;
    padding: 12px 12px 12px 60px;
    margin: 24px auto;
    border-radius: 3px;

    .info {
      width: calc(100% - 200px);
    }
    .text {
      display: inline-block;
      font-size: 18px;
      margin: 0;
      padding: 0;
      color: $warning-color-text;
    }
    .message_error {
      color: #666;
      display: inline-block;
    }

    .actions {
      @include display-flex();
      @include align-items();
      @include flex-wrap(wrap);
      display: inline-block;
      width: 200px;
      height: 100%;
      text-align: right;
    }
    .value {
      margin: 0;
      display: inline-block;
      width: 60px;
      height: 32px;
      border: 1px solid $warning-color;
      color: $warning-color-text;
      border-radius: 3px;
      font-size: 22px;
      text-align: right;
    }
    .btn {
      display: inline-block;
      width: 100px;
      background-color: #fff;
      border-radius: 3px;
      padding: 6px 12px;
      margin-left: 16px;
    }

    &.error {
      .value {
        border-color: $alert-color;
        color: $alert-color;
      }
    }

    &.informative {
      background-image: img("person_main.svg");
      background-color: $secondary-color;
      background-size: 26px;
      padding-left: 50px;
      cursor: pointer;

      .text {
        color: $main-color;
      }
    }
  }

  .actions .alert {
    @include flex-direction(column);
    @include background($image: none);
    width: 95%;
    padding: 9px;
    margin: 12px auto;
    border-radius: 3px;

    .info {
      width: 100%;
      margin-bottom: 6px;
      text-align: center;
    }
    .text {
      font-size: 16px;
    }
    .message_error {
      font-size: 13px;
    }
    .actions {
      text-align: center;

      .btn {
        width: auto;
      }
    }
  }

  .layout {
    display: block;
    column-width: calc(33% - 24px);
    column-count: 3;
    column-gap: 12px;
  }

  .teamInfo {
    @include height-fit-content();
    background-color: $secondary-color;
    border-radius: 3px;
    width: 100%;
    margin-bottom: 12px;
    display: block;
    overflow: auto;
    break-inside: avoid;

    .team,
    .resume,
    .gestor,
    .actions {
      width: 100%;
      cursor: pointer;
    }

    .team {
      margin: 0;
      border-radius: 3px 3px 0 0;
      padding: 3px 6px 6px 6px;
      background-color: $main-color-t20;
      color: #fff;

      .category {
        display: inline-block;
        font-size: 15px;
        text-transform: uppercase;
        font-weight: bold;
        margin-right: 6px;
        color: inherit;
      }
      .name {
        display: inline-block;
        font-size: 16px;
        color: inherit;
      }
    }

    .resume {
      border-bottom: 1px solid $main-color-t80;

      .item {
        display: inline-block;
        width: 33%;
        text-align: center;
        height: auto;
        vertical-align: top;

        .value,
        .label {
          text-align: center;
          display: block;
          font-weight: bold;
        }
        .value {
          height: 50px;
          line-height: 50px;
          font-size: 30px;
          color: inherit;

          .total {
            color: inherit;
          }
        }
        .label {
          // line-height: 6px;
          height: auto;
          font-size: 12px;
          text-transform: uppercase;
          color: inherit;
          word-break: break-word;
        }

        &.empty {
          @include background(
            $image: img("empty_estimated_warning.svg"),
            $size: 30px,
            $position: top 10px center
          );
          // @include background( $image: img('empty_estimated_warning.svg'), $size: 30px, $position: top 10px center, $color: $warning-color-light );

          .value {
            color: transparent;
          }
        }
      }
    }

    .gestor {
      @include text-ellipsis();
      @include background(
        $image: img("user_filled.svg"),
        $size: 18px,
        $position: left 12px center
      );
      padding-left: 36px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      // text-transform: capitalize;
      cursor: initial;

      &.empty {
        @include background(
          $image: (
            img("user_empty.svg"),
            img("right-arrow.svg")
          ),
          $size: (
            18px,
            12px
          ),
          $position: (
            left 12px center,
            right 9px center
          )
        );
        padding-right: 24px;
        cursor: pointer;
      }
    }
  }

  @include media("<=desktop") {
    #content {
      .alerts {
        padding: 0;
        margin: 0;

        .alert,
        .error {
          width: 100%;
          .info {
            width: 100%;
          }
        }
      }
    }

    .home-title {
      font-size: 26px;
      line-height: 26px;
      padding: 12px 0 0px 0;

      &:after {
        margin: 18px auto 6px auto;
      }
    }
    .description {
      font-size: 20px;
      line-height: 20px;
    }
  }

  @include media(">=tablet", "<desktop") {
    .background {
      height: 150px;
    }

    #content {
      padding-top: 100px;
    }

    .layout {
      column-count: 2;
    }
  }

  @include media(">1023px", "<1401px") {
    .layout {
      column-count: 2;
    }
  }

  @include media(">phone", "<tablet") {
    .background {
      height: 125px;
      top: 50px;
    }
    #content {
      padding-top: 125px;
    }
    .home-header {
      display: block;
    }

    .layout {
      column-count: 1;
    }
  }
}
</style>
